import React from 'react';
import styles from './QRCode.module.css';
import qrcodeImage from '../../assets/images/qrcode.png';
import qrBg from '../../assets/images/qrcode.png';

interface QRCodeProps {
  userName?: string;
  highestScore?: number;
}

const QRCode: React.FC<QRCodeProps> = ({ userName, highestScore = 0 }) => {
  const containerStyle = {
    '--qr-bg': `url(${qrBg})`
  } as React.CSSProperties;

  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.qrcode}>
        <div className={styles.qrcodeImage}>
          <img src={qrcodeImage} alt="扫码访问网站" />
        </div>
        <p>扫码访问网站</p>
        {userName && (
          <div className={styles.welcomeInfo}>
            <h3>欢迎回来，{userName}！</h3>
            {highestScore > 0 && (
              <p className={styles.score}>历史最高分：{highestScore}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default QRCode; 